export default __webpack_public_path__ + "static/media/016-positive ion.88c0c14f.svg";